import { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { retrySearch } from "../../state/modules/search/actions";
import Spinner from "../Spinner";
import styles from "./AutoRetry.css";

export class AutoRetry extends Component {
  componentDidMount() {
    this.props.retrySearch();
  }

  render() {
    return (
      <div className={styles.container} data-auto-id="autoRetryListSpinner">
        <Spinner size="large" />
      </div>
    );
  }
}

AutoRetry.propTypes = {
  retrySearch: PropTypes.func.isRequired
};

AutoRetry.displayName = "AutoRetry";

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      retrySearch
    },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(AutoRetry);
